import ReactGA from "react-ga";
import { useEffect } from "react";

export const useGoogleAnalytics = () => {
  useEffect(() => {
    ReactGA.initialize("G-H6H4KZQ2YD");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
};
